var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    [
      _c("MobileHeader", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.main }, [
        _c("div", { class: _vm.$style.mainTop }, [
          _c("img", {
            class: _vm.$style.mainLogo,
            attrs: {
              srcset:
                require("@/assets/img/LOGO@2x.png") +
                ", " +
                require("@/assets/img/LOGO.png"),
              src: require("@/assets/img/LOGO.png"),
              alt: "Burger Boss"
            }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showWelcomeText,
                  expression: "showWelcomeText"
                }
              ],
              class: _vm.$style.welcomeText
            },
            [_vm._v("Welcome Back!")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.mainBottom },
          [
            _c("router-view", {
              on: {
                "link-sent": function($event) {
                  return _vm.forgotPasswordSuccess()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "MobileModal",
        {
          attrs: { dialog: "", "center-content": "" },
          model: {
            value: _vm.showPasswordResetMsg,
            callback: function($$v) {
              _vm.showPasswordResetMsg = $$v
            },
            expression: "showPasswordResetMsg"
          }
        },
        [
          _c(
            "MobileConfirmDialog",
            {
              attrs: {
                title: "Password Reset",
                "confirm-text": "OK",
                "cancel-disabled": ""
              },
              on: {
                confirm: function($event) {
                  return _vm.goToMain()
                }
              }
            },
            [_vm._v("\n      Please check your email for a link.\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileSignIn.vue?vue&type=template&id=02532b84&
// module id = null
// module chunks = 